<!--
 * @Description: 发票管理 - 代办供应商端（票税修改）
 * @Date: 2026-06-04
-->
<template>
  <div>
    <BaseTabs style="margin: 10px 0" v-model="subTab" v-if="subTabs.length > 1">
      <BaseTabPane
        v-for="item in subTabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      />
    </BaseTabs>
    <component :is="curCmopt" v-bind="curCmoptProps" />
  </div>
</template>
<script lang="tsx" setup>
import { ref, onMounted, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { DBGYS_TABS } from '@V/invoice/src/constants';
import { RouteQuery } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';

const route = useRoute();
const routeQuery = route.query as RouteQuery;

const subTab = ref(1);
const subTabs = computed(() => Object.values(DBGYS_TABS));
const curCmopt = computed(() => DBGYS_TABS[subTab.value]?.cmpt);
const curCmoptProps = computed(() => {
  const child = DBGYS_TABS[subTab.value];
  // type 既作开票记录的 invoiceTabType，也作待开票（复用 gt 列表）的 scene 标记
  return { invoiceTabType: (child as any)?.type, scene: (child as any)?.type };
});

onMounted(async () => {
  subTab.value = +(routeQuery.subTab || 1);
});
</script>
